import React, { ReactNode } from 'react'

import { UserRole } from '../../user'

import { RoleGuard } from './RoleGuard'

type RoleGuardedComponentPropsType = {
  roles: UserRole[]
  isRoute?: boolean
  children: ReactNode
}

// Component
export const RoleGuardedComponent: React.FC<RoleGuardedComponentPropsType> = ({
  roles,
  children,
}) => {
  return (
    <RoleGuard roles={roles} isRoute={false}>
      {children}
    </RoleGuard>
  )
}

export default RoleGuardedComponent
